import React from 'react';
import { Card, Badge, Btn, Divider, Stepper, Header, BottomNav, CheckIcon, MessageIcon } from '../components/SharedComponents';
import C from '../styles/tokens';

const BuyOrderStatus = ({ navigate }) => (
  <div className="page-wrapper slide-up">
    <Header title="Order Status" onBack={() => navigate('dashboard')} />

    <div className="page-content-lg">

      {/* Success Icon */}
      <div className="text-center mb-24">
        <div className="success-icon-wrap success-icon-wrap-green" style={{ margin: '0 auto 14px' }}>
          <CheckIcon color={C.accent} size={32} strokeWidth={2.5} />
        </div>
        <h2 style={{ fontWeight: 900, fontSize: 22, color: C.textPrimary }}>
          Order Completed!
        </h2>
        <p style={{ color: C.textSecondary, fontSize: 14, marginTop: 6 }}>
          Your USDT has been credited to your wallet
        </p>
      </div>

      {/* Order Detail Card */}
      <Card style={{ marginBottom: 16 }}>
        <div className="flex justify-between items-center mb-10">
          <span className="font-mono" style={{ fontSize: 12, color: C.textMuted }}>
            Order #XD73826A9F01
          </span>
          <Badge color={C.accent}>Completed</Badge>
        </div>
        <Divider />
        {[
          { label: 'You Paid',       val: '₹900' },
          { label: 'You Received',   val: '10 USDT',  valColor: C.accent },
          { label: 'Submitted At',   val: '11:45 AM' },
          { label: 'Credited At',    val: '12:25 PM' },
        ].map((row, i) => (
          <div key={i}>
            <div className="flex justify-between items-center" style={{ padding: '9px 0' }}>
              <span style={{ fontSize: 13, color: C.textMuted }}>{row.label}</span>
              <span style={{ fontWeight: 700, fontSize: 14, color: row.valColor || C.textPrimary }}>
                {row.val}
              </span>
            </div>
            {i < 3 && <Divider />}
          </div>
        ))}
      </Card>

      {/* Stepper */}
      <Card style={{ marginBottom: 20 }}>
        <Stepper steps={[
          { label: 'Order Created',               status: 'done', time: 'Today, 11:45 AM' },
          { label: 'Payment Screenshot Uploaded', status: 'done', time: 'Today, 11:45 AM' },
          { label: 'Under Manual Verification',   status: 'done', time: 'Today, 12:25 PM' },
          { label: 'USDT Credited Successfully',  status: 'done', time: 'Today, 12:25 PM' },
        ]} />
      </Card>

      {/* Help Note */}
      <div className="alert-info">
        <MessageIcon />
        <div style={{ fontSize: 13, color: C.textSecondary }}>
          Need help? Contact support with your Transaction ID and we'll respond within 10 minutes.
        </div>
      </div>

      <Btn onClick={() => navigate('dashboard')} variant="primary" full size="lg">
        Back to Dashboard
      </Btn>
    </div>

    <BottomNav active="buy" navigate={navigate} />
  </div>
);

export default BuyOrderStatus;
